import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { FormControl, FormGroup, Validators, FormBuilder } from "@angular/forms";

import { MatDialog, MatDialogRef, MatTable, MAT_DIALOG_DATA } from "@angular/material";
import * as moment from 'moment';

import { ViewBatchComponent } from "./view-batch/view-batch.component";
import { EditBatchLabelComponent } from "./edit-batch-label/edit-batch-label.component";
import { PreInnerBatchLabelComponent } from './pre-inner-batch-label/pre-inner-batch-label.component';
import { BatchService } from "src/services/batch.services";
import { GlobalCfgService } from "src/services/globalcfg.service";
import { MedicineService } from "src/services/medicine.services";
import { MessageService } from '../../../services/message.service';
import { SubscriptionService } from '../../../services/subscription.service';
import { Utils } from 'src/services/utils';

@Component({
    selector: 'rm-create-bulk-batch-label',
    templateUrl: './bulk-batch-label.component.html',
    styleUrls: ['./bulk-batch-label.component.css']
})

export class BulkBatchLabelComponent implements OnInit {
    form: FormGroup;
    gcp: string;
    medicines: any[];
    isExistingBatch: boolean = false;
    mfgDate: any;
    expiryDate: string;
    //bulk batch grid data varaible
    batchData: any[] = [];
    batchDetails: any;
    columns: any[];
    grossValue: number = null;
    tareValue: number = null;
    netValue: number = null;
    isLabelAlsoInner: boolean = false;
    containerValue: number = null;
    totalContainers: number;
    totalNetWeight: number = 0;
    currentOrgObj: any;
    showOrigin: boolean = false;
    disableSelectedBatch: boolean = false;
    selectedBatchBulkDetails: any;
    isBatchDetailsData: boolean;
    viewBatchDetailsData: any = [];

    constructor(
        private dialogRef: MatDialogRef<BulkBatchLabelComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private dialog: MatDialog,
        private medicineService: MedicineService,
        private batchService: BatchService,
        // private msgService: MessageService,
        private globalCfgService: GlobalCfgService,
        private _formBuilder: FormBuilder,
        private msgService: MessageService,
        private subscriptionService: SubscriptionService,
        private utils: Utils,
    ) {

    }


    ngOnInit() {
        //Grid columuns data  
        this.columns = [
            { name: 'grossweight', displayName: "Gross Weight", actionable: true, },
            { name: 'tareweight', displayName: "Tare Weight", actionable: true, },
            { name: 'netweight', displayName: "Net Weight", actionable: true, },
            { name: 'container', displayName: "Container", actionable: true, },
            { name: "actions", type: "actions", displayName: "" },
        ];

        this.form = this._formBuilder.group({
            isNeutralLabel: false,
            showOrigin: false,
            gtin: new FormControl(),
            toPrintCustomProductName: false,
            toPrintProductName: new FormControl(),
            updateExistingBatch: false,
            batchNo: new FormControl(),
            aRNo: '',
            mfgDate: new FormControl({ disabled: true, value: '' }, [Validators.required]),
            expiryDate: new FormControl({ disabled: true, value: '' }, [Validators.required]),
            expiryDateType: 'expiry',
            storageCondition: '',
            casNum: '',
            totalProductionQty: new FormControl(null, [Validators.required, Validators.min(0.000001)])
        });

        this.setOrgData();

        this.loadMedicines();
        this.totalContainers = this.batchData.length;
    }

    setOrgData() {
        if (!this.gcp) {
            this.gcp = this.globalCfgService.getGcp();

            // get current org data to check if isAlsoInner or isOnlyInner option is to be displayed
            const filter = { "where": { "gcp": this.globalCfgService.getGcp() } };
            this.subscriptionService.getCurrentOrgData(filter).subscribe(
                (response: any) => {
                    if (response.count === 1) {
                        this.currentOrgObj = response.data[0];
                        //parse stringified bulkApiAttributes
                        this.currentOrgObj = this.convertBulkApiAttributes(this.currentOrgObj);
                        // check & add controls to form for custom fields
                        if (this.currentOrgObj) {
                            if (this.currentOrgObj.bulkApiAttributes) {
                                if (this.currentOrgObj.bulkApiAttributes.customFields) {
                                    this.currentOrgObj.bulkApiAttributes.customFields.forEach((field) => {
                                        if (field.required) {
                                            this.form.addControl(field.fieldName, new FormControl('', [Validators.required]));
                                        } else {
                                            this.form.addControl(field.fieldName, new FormControl());
                                        }
                                    });
                                }
                            }
                        }
                        console.log(this.form.controls);
                        // console.log(this.currentOrgObj.isInnerUsed);
                    }
                }
            );

            // get the batch details and pass the data to the view batch dialog..
            let obj: any = { 'gcp': this.globalCfgService.getGcp() };
            this.batchService.get(obj).subscribe((response: any[]) => {
                this.isBatchDetailsData = response['result'].length > 0 ? true : false;
                this.viewBatchDetailsData = response['result']
            });
        }
    }

    convertBulkApiAttributes(orgDataObj) {
        if (orgDataObj.bulkApiAttributes) {
            orgDataObj.bulkApiAttributes = JSON.parse(JSON.parse(orgDataObj.bulkApiAttributes));
            console.log(orgDataObj);
        }
        return orgDataObj;
    }

    loadMedicines() {

        var gcp = this.globalCfgService.getGcp();

        this.medicineService.getList(gcp).subscribe(
            (response: any) => {
                this.medicines = response;
            }
        );
    }

    productSelectionChange(selectedGtin) {
        let selectedProductIdx = this.medicines.findIndex(med => med.gtin === selectedGtin);
        this.form.patchValue({ 'toPrintProductName': this.medicines[selectedProductIdx].name });
        this.getSelectedProductDetail(selectedGtin);
    }

    getSelectedProductDetail(selectedGtin) {
        this.medicineService.getProductData(selectedGtin).subscribe(
            (response: any) => {
                this.form.patchValue({
                    'storageCondition': response.attributes.storageCondition,
                    'casNum': response.attributes.casNum
                });
                // product's date type is only a default for a new batch, user can still change it
                if (this.isExpiryDateTypeEnabled() && !this.disableSelectedBatch) {
                    this.form.patchValue({ expiryDateType: response.attributes.expiryDateType || 'expiry' });
                }
            }
        );
    }

    // to check if toPrintProductName is empty and then 
    // set it default name of product selected when checkbox is enabled
    checkAndSetToPrintProductName(toPrintCustomProductNameUpdatedVal: boolean) {
        if (toPrintCustomProductNameUpdatedVal && (this.form.value.toPrintProductName === null || this.form.value.toPrintProductName === '')) {
            if (this.form.value.gtin !== null) {
                let selectedProductIdx = this.medicines.findIndex(med => med.gtin === this.form.value.gtin);
                this.form.patchValue({ 'toPrintProductName': this.medicines[selectedProductIdx].name });
            }
        }
    }

    cancel() {
        this.dialogRef.close();
    }

    onSubmit() { }

    setBatchDate(e) {
        this.mfgDate = e;
        this.form.patchValue({ mfgDate: this.mfgDate });
    }

    setExpiryDate(e) {
        this.expiryDate = e;
        this.form.patchValue({ expiryDate: this.expiryDate });
    }

    isExpiryDateTypeEnabled() {
        return this.currentOrgObj && this.currentOrgObj.bulkApiAttributes && this.currentOrgObj.bulkApiAttributes.showExpiryDateType;
    }

    getExpiryDateLabel() {
        if (this.isExpiryDateTypeEnabled()) {
            return this.form.get('expiryDateType').value === 'retest' ? 'Retest Date' : 'Expiry Date';
        }
        return this.currentOrgObj && this.currentOrgObj.isInnerUsed ? 'Expiry/Retest Date' : 'Expiry Date';
    }

    /**
     * Some orgs work from the tare of the empty container and the net quantity
     * filled into it, so they enter those two and gross is the computed sum.
     * Only gross and tare are ever persisted either way.
     */
    get isNetWeightEntry(): boolean {
        return !!(this.currentOrgObj && this.currentOrgObj.isNetWeightEntered);
    }

    /** live gross for the read only box; null until both operands are filled */
    get computedGrossValue(): number {
        return this.utils.grossFromTareAndNet(this.tareValue, this.netValue);
    }

    addBulkLabel() {
        const gross = this.isNetWeightEntry ? this.computedGrossValue : this.grossValue;

        if (gross && this.tareValue && this.containerValue) {
            let newLbelObj: any = {
                grossweight: gross,
                tareweight: this.tareValue,
                netweight: (gross - this.tareValue).toFixed(this.currentOrgObj.labelWeightDecimals ? this.currentOrgObj.labelWeightDecimals : 3),
                isAlsoInner: false,
                isOnlyInner: false,
                container: this.containerValue,
                actions: [{ name: 'close', tip: 'delete' }]
            };
            if (this.currentOrgObj.isInnerUsed) {
                if (this.currentOrgObj.isRegularInnerType) {
                    newLbelObj.isOnlyInner = this.isLabelAlsoInner;
                } else {
                    newLbelObj.isAlsoInner = this.isLabelAlsoInner;
                }
            }
            this.batchData.push(newLbelObj);
            this.grossValue = null;
            this.tareValue = null;
            this.netValue = null;
            this.containerValue = null;
            if (this.currentOrgObj.isInnerUsed) {
                this.isLabelAlsoInner = false;
            }
            // this.totalNetWeightValue();
        }
    }

    removeBulkLabel(index) {
        if (index > -1) {
            this.batchData.splice(index, 1);
        }
        // this.totalNetWeightValue();
    }

    updateBulkLabel(index) {
        const dialogRef2 = this.dialog.open(EditBatchLabelComponent, {
            disableClose: true,
            width: "500px",
            data: {
                title: 'Edit Bulk API Batch Label',
                batchLabel: this.batchData[index],
                currentOrgObj: this.currentOrgObj
            }
        });

        dialogRef2.afterClosed().subscribe((result: any) => {
            if (result) {
                this.batchData.splice(index, 1, result.data);
            }
        })
    }

    //pre-inner bulk api label add
    addPreInnerLabel(actionType, parentLabelIdx, innerLabelIdx) {

        const preInnerDialogRef = this.dialog.open(PreInnerBatchLabelComponent, {
            disableClose: true,
            width: "500px",
            data: {
                title: 'Add/Edit Pre Inner Bulk API Batch Label',
                batchLabel: this.batchData[parentLabelIdx],
                actionType: actionType,
                innerLabelIdx: innerLabelIdx,
                currentOrgObj: this.currentOrgObj
            }
        });

        preInnerDialogRef.afterClosed().subscribe((result: any) => {
            if (result) {
                // this.totalNetWeightValue();
                this.batchData.splice(parentLabelIdx, 1, result.data);
            }
        })
    }

    // totalNetWeightValue() {
    //     this.totalContainers = this.batchData.length;
    //     this.totalNetWeight = this.batchData.reduce((accumulator, currentValue) => accumulator + currentValue.netweight, 0);
    // }

    //generate the bulk batch label api integration...
    generateBulkBatchLabel(param) {

        if (this.isOverProduction) {
            this.msgService.showError(this.msgService.productionQtyExceeded);
            return;
        }

        let filterBatchData = [];
        this.batchData.forEach((it) => {
            let refObj: any = {
                grossweight: it.grossweight,
                tareweight: it.tareweight,
                isAlsoInner: it.isAlsoInner,
                isOnlyInner: it.isOnlyInner,
                container: it.container
            }
            filterBatchData.push(refObj);
            if (it.innerLabels && it.innerLabels.length > 0) {
                it.innerLabels.forEach((preInnerLabel) => {
                    let preInnerObj: any = {
                        grossweight: preInnerLabel.grossweight,
                        tareweight: preInnerLabel.tareweight,
                        isAlsoInner: preInnerLabel.isAlsoInner,
                        isOnlyInner: preInnerLabel.isOnlyInner,
                        container: preInnerLabel.container,
                        parentContainer: preInnerLabel.parentContainer
                    }
                    filterBatchData.push(preInnerObj);
                });
            }
        })

        let timeZoneOffSetVal;
        if (this.isExistingBatch) {
            timeZoneOffSetVal = this.batchDetails.eventTimeZoneOffset;
        } else {
            timeZoneOffSetVal = this.utils.getTimeZoneFromDateString(moment(this.mfgDate).format());
        }

        let rec: any = {
            batchNo: param.batchNo,
            gtin: param.gtin,
            toPrintCustomProductName: param.toPrintCustomProductName,
            toPrintProductName: param.toPrintCustomProductName ? param.toPrintProductName : '',
            mfgDate: this.mfgDate,
            expiryDate: this.expiryDate,
            eventTimeZoneOffset: timeZoneOffSetVal,
            isNeutralLabel: param.isNeutralLabel,
            storageCondition: param.storageCondition,
            casNum: param.casNum,
            children: filterBatchData
        }

        // add custom fields to payload
        if (this.currentOrgObj) {
            if (this.currentOrgObj.bulkApiAttributes) {
                if (
                    this.currentOrgObj.bulkApiAttributes.customFields && 
                    this.currentOrgObj.bulkApiAttributes.customFields.length > 0
                ) {
                    rec.bulkApiBatchCustomFields = [];
                    this.currentOrgObj.bulkApiAttributes.customFields.forEach((field) => {
                        let customFiledsObj = {};
                        customFiledsObj[field.fieldName] = param[field.fieldName];
                        rec.bulkApiBatchCustomFields.push(customFiledsObj);
                    });
                }
            }
        }

        // expiry or retest date type is saved with batch custom fields
        if (this.isExpiryDateTypeEnabled()) {
            if (!rec.bulkApiBatchCustomFields) {
                rec.bulkApiBatchCustomFields = [];
            }
            rec.bulkApiBatchCustomFields.push({ expiryDateType: param.expiryDateType || 'expiry' });
        }

        if (!this.isExistingBatch) {
            // only a new batch declares its production quantity - an existing
            // batch already carries one and it is immutable
            rec.totalProductionQty = Number(param.totalProductionQty);
        }

        if (this.currentOrgObj.isInnerUsed) {
            rec.aRNo = param.aRNo;
            rec.showOrigin = param.showOrigin;
        }

        // passing batch obj (rec), timezoneVal, form data
        let refRec = this.mapBatchDetailsToLabels(rec, timeZoneOffSetVal, param);

        if (this.isExistingBatch) {
            //create the bulk batch labels with existing batch.....
            this.selectedBulkBatchDetails(refRec, this.selectedBatchBulkDetails, param);
        } else {
            //create the bulk batch labels new batch.....api integration
            // console.log(refRec);
            this.batchService.genBulkBatchLabels(refRec).subscribe((response: any) => {
                if (response) {
                    this.msgService.showSuccess(this.msgService.bulkBatchCreate);
                    response.labelFiles.forEach(labelFile => {
                        window.open(labelFile, '_blank');
                    });
                    this.dialogRef.close(response);
                } else {
                    this.msgService.showError(this.msgService.bulkBatchCreateFail);
                }
            })
        }
    }

    viewExistingBatchLabels(isChecked: boolean) {
        this.isExistingBatch = isChecked;
        if (isChecked) {
            // an existing batch already carries its production quantity - the
            // control is not applicable, and leaving it required would keep the
            // form invalid and block this path
            this.form.get('totalProductionQty').disable();
            this.openExistingBatchSelectionDialog();
        } else {
            this.form.enable();
            this.form.reset();
            this.form.patchValue({ expiryDateType: 'expiry' });
            this.mfgDate = null;
            this.expiryDate = null;
            this.disableSelectedBatch = false;
            this.batchDetails = null;
        }
    }

    // ------------------------------------------------------------------
    // Batch quantity reconciliation (client side convenience only - the
    // network API and the chaincode remain authoritative)
    // ------------------------------------------------------------------

    get uomLabel(): string {
        return this.currentOrgObj && this.currentOrgObj.uom ? this.currentOrgObj.uom : '';
    }

    /**
     * Net weight of the containers pending in this dialog.
     * batchData holds only top level containers - pre-inner labels live in
     * batchData[i].innerLabels and their mass is already inside their parent -
     * so this naturally excludes them. Number() is required because netweight is
     * a toFixed string and would otherwise concatenate.
     */
    get pendingQty(): number {
        return this.batchData.reduce(
            (total, label) => total + (Number(label.grossweight) - Number(label.tareweight)), 0);
    }

    get totalProductionQty(): number {
        if (this.isExistingBatch) {
            return this.batchDetails && this.batchDetails.totalProductionQty !== undefined
                ? Number(this.batchDetails.totalProductionQty) : null;
        }
        const value = this.form.get('totalProductionQty').value;
        return value === null || value === '' ? null : Number(value);
    }

    /** quantity already issued against the batch, per the server */
    get issuedQty(): number {
        return this.isExistingBatch && this.batchDetails && this.batchDetails.utilisedQty !== undefined
            ? Number(this.batchDetails.utilisedQty) : 0;
    }

    get utilisedQty(): number {
        return this.issuedQty + this.pendingQty;
    }

    get remainingQty(): number {
        return this.totalProductionQty === null ? null : this.totalProductionQty - this.utilisedQty;
    }

    get isProductionQtyTracked(): boolean {
        return this.totalProductionQty !== null;
    }

    get isOverProduction(): boolean {
        return this.isProductionQtyTracked && this.remainingQty < 0;
    }

    openExistingBatchSelectionDialog() {
        const dialogRef = this.dialog.open(ViewBatchComponent, {
            disableClose: true,
            width: "750px",
            data: {
                title: 'Select Batch',
                viewbatchData: this.viewBatchDetailsData
            }
        });

        dialogRef.afterClosed().subscribe((result: any) => {
            if (result) {
                this.selectedBatchBulkDetails = result['data'];
                this.disableSelectedBatch = true;
                this.batchService.getBatchDetails(result.data.batchNo).subscribe((res: any) => {
                    this.batchDetails = res;
                    this.form.patchValue({
                        gtin: result['data'].gtin,
                        batchNo: result['data'].batchNo,
                        expiryDate: result['data'].expiryDt,
                        mfgDate: result['data'].batchDt,
                        toPrintCustomProductName: true,
                    });
                    this.mfgDate = this.batchDetails.mfgDate;
                    this.expiryDate = this.batchDetails.expiryDate;

                    // set custom product name & storage condition
                    this.form.patchValue({ toPrintCustomProductName: true });
                    let selectedProductIdx = this.medicines.findIndex(med => med.gtin === result['data'].gtin);
                    this.form.patchValue({ 'toPrintProductName': this.medicines[selectedProductIdx].name });
                    this.getSelectedProductDetail(result['data'].gtin);

                    // set it default name of product selected
                    this.checkAndSetToPrintProductName(true);

                    if (res.isNeutralLabel) {
                        this.form.patchValue({ 'isNeutralLabel': res.isNeutralLabel });
                    } else {
                        this.form.patchValue({ isNeutralLabel: false });
                    }
                    if (this.currentOrgObj.isInnerUsed) {
                        this.prefillFromExistingLabels(result['data'].batchNo);
                    }

                    // batches saved without a date type were printed as expiry
                    this.form.patchValue({ expiryDateType: 'expiry' });

                    // batch custom fields mapping
                    if (
                        this.batchDetails.bulkApiBatchCustomFields &&
                        this.batchDetails.bulkApiBatchCustomFields.length > 0
                    ) {
                        let customFields = JSON.parse(this.batchDetails.bulkApiBatchCustomFields);
                        customFields.forEach((field) => {
                            const keys = Object.keys(field);
                            const fieldName = keys[0];
                            this.form.patchValue({ [fieldName]: field[keys[0]] });
                        });
                        
                    }

                    this.form.get('batchNo').disable();
                    this.form.get('gtin').disable();
                });
                // this.form.get('batchNo').patchValue(result['data'].batchNo, {disabled: true});
            }

        });
    }

    /**
     * A.R. No and storage condition are the same for every label of a batch but
     * live on the label metadata, not on the batch, so read them back off the
     * labels already issued rather than making the operator remember and retype
     * them. They stay editable.
     */
    prefillFromExistingLabels(batchNo) {
        // clear first, so re-picking a different batch cannot leak the previous one's values
        this.form.patchValue({ aRNo: '', storageCondition: '' });

        this.batchService.getBulkApiBatchLabel(batchNo).subscribe((res: any) => {
            // A.R. No is hidden for a regular inner type org, so it must not be
            // filled in behind their back - the submit path sends whatever the
            // control holds
            const fields = this.currentOrgObj.isRegularInnerType
                ? ['storageCondition']
                : ['aRNo', 'storageCondition'];
            this.form.patchValue(this.utils.getBulkLabelDefaults(res, fields));
        });
    }

    //create the bulk batch labels with existing batch api integration..
    selectedBulkBatchDetails(rec, batch, formValues) {
        let refObj: any = {
            batchNo: batch['batchNo'],
            toPrintCustomProductName: rec.toPrintCustomProductName,
            toPrintProductName: rec.toPrintCustomProductName ? rec.toPrintProductName : '',
            children: rec.children,
        }

        // check and add custom fields to payload
        if (this.currentOrgObj) {
            if (this.currentOrgObj.bulkApiAttributes) {
                if (
                    this.currentOrgObj.bulkApiAttributes.customFields && 
                    this.currentOrgObj.bulkApiAttributes.customFields.length > 0
                ) {
                    refObj.bulkApiBatchCustomFields = rec.bulkApiBatchCustomFields;
                }
            }
        }
        if (this.isExpiryDateTypeEnabled()) {
            refObj.bulkApiBatchCustomFields = rec.bulkApiBatchCustomFields;
        }


        this.batchService.addLabelToExisitngBulk(refObj).subscribe((res: any) => {
            this.msgService.showSuccess(this.msgService.bulkBatchCreate);
            res.labelFiles.forEach(labelFile => {
                window.open(labelFile, '_blank');
            });
            this.dialogRef.close(res);
        })
    }
    
    //map batchdetails into children except batchNo
    mapBatchDetailsToLabels(rec, timeZone, formVal) {
        if (rec.children.length > 0) {
            let refObj = {
                // gtin: rec.gtin,
                toPrintCustomProductName: rec.toPrintCustomProductName,
                toPrintProductName: rec.toPrintProductName,
                mfgDate: this.mfgDate,
                expiryDate: this.expiryDate,
                eventTimeZoneOffset: timeZone,
                isNeutralLabel: rec.isNeutralLabel
            }
            if (rec.aRNo) {
                refObj['aRNo'] = rec.aRNo;
            }
            if (rec.storageCondition) {
                refObj['storageCondition'] = rec.storageCondition;
            }
            if (rec.casNum) {
                refObj['casNum'] = rec.casNum;
            }
            if (rec.showOrigin) {
                refObj['showOrigin'] = rec.showOrigin;
            }
            // add custom fields to each label payload
            if (this.currentOrgObj) {
                if (this.currentOrgObj.bulkApiAttributes) {
                    if (
                        this.currentOrgObj.bulkApiAttributes.customFields && 
                        this.currentOrgObj.bulkApiAttributes.customFields.length > 0
                    ) {
                        refObj['bulkApiLabelCustomFields'] = [];
                        this.currentOrgObj.bulkApiAttributes.customFields.forEach((field) => {
                            let customFiledsObj = {};
                            customFiledsObj[field.fieldName] = formVal[field.fieldName];
                            refObj['bulkApiLabelCustomFields'].push(customFiledsObj);
                        });
                    }
                }
            }
            const labelChildren = rec.children.map((it) => { return { ...it, ...refObj } })

            rec.children = labelChildren;
        }
        return rec;
    }
}